module.exports = __webpack_public_path__ + "static/img/bot-step-2.bc2596c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bot-step-2.png
// module id = qaVQ
// module chunks = 11